import getAssetsUrl from './get-assets-url';
import getPages from './get-pages';
import getSiteId from './get-site-id';
import getSiteName from './get-site-name';
import getActivePageId from './get-active-page-id';
import getUserEmails from './get-user-emails';
import getOwnerId from './get-owner-id';
import getPageTemplateId from './get-page-template-id';
import getActivePage from './get-active-page';
import getRedirects from './get-redirects';
import getPage from './get-page';
import getSiteProperties from './get-site-properties';
import getSettings from './get-settings';
import getBusinessCategory from './get-business-category';

export default {
  getAssetsUrl,
  getPages,
  getSiteId,
  getSiteName,
  getActivePageId,
  getUserEmails,
  getOwnerId,
  getPageTemplateId,
  getActivePage,
  getRedirects,
  getPage,
  getSiteProperties,
  getSettings,
  getBusinessCategory,
};
